import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const libroreclamacionesAdd = createAsyncThunk(
  "libroreclamaciones/libroreclamacionesAdd",
  async (formData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/reclamo/add-reclamo", formData, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Error al enviar el reclamo" });
    }
  }
);

export const libroreclamacionesReducer = createSlice({
  name: "libroreclamaciones",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(libroreclamacionesAdd.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
        state.successMessage = "";
      })
      .addCase(libroreclamacionesAdd.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload?.error || "Error al enviar el reclamo";
      })
      .addCase(libroreclamacionesAdd.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
      });
  },
});

export const { messageClear } = libroreclamacionesReducer.actions;
export default libroreclamacionesReducer.reducer;
